import { Header as KandaHeader, Logo } from '@kanda-libs/ks-design-library';

import Steps from './Steps';
import { CLASS_NAMES } from './constants';

interface HeaderProps {
  showSteps?: boolean;
  help?: (e?: React.MouseEvent<HTMLElement>) => void;
}

const Header = ({ showSteps, help }: HeaderProps) => (
  <KandaHeader.Base help={help} lines>
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.titleWrapper}>
        <Logo height={67} />
      </div>
      {showSteps && (
        <div className="w-screen -ml-6 px-4">
          <div className="w-full overflow-scroll">
            <Steps />
          </div>
        </div>
      )}
    </div>
  </KandaHeader.Base>
);

Header.defaultProps = {
  showSteps: false,
};

export default Header;
